import React from 'react';
import './../../App.css';
import { API, graphqlOperation, Auth} from 'aws-amplify'

async function onLogoutfn() {
    console.log('got to onLogoutfn')
    try {
        await Auth.signOut();
        window.location.replace('/')
    } catch (error) {
        console.log('error signing out: ', error);
    }
}

function Nav() {

    return (
        <header>
            <a className="navbar-brand" href="/ESORMA">
                <span className='coname2'>ESORMA<span className="logo-spot">.</span></span>
            </a>
            <input type='checkbox' className='nav-toggle' id='nav-toggle' />
            <nav>
                <ul>
                  <li>
                      <a href='/'>Home</a>
                  </li>
                  <li>
                      <a href='/training'>Training</a>
                  </li>
                  <li>
                      <a href='getintouch'>Get In Touch</a>
                  </li>
                  <li>
                      <a href='#' onClick={onLogoutfn}> Quit</a>
                  </li>
                </ul>
            </nav>
            <label for="nav-toggle" className='nav-toggle-label'>
                <span></span>
            </label>
        </header>
    )
}

export default Nav;
